// assets
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import ApartmentOutlined from '@ant-design/icons/ApartmentOutlined';

// icons
const icons = { TeamOutlined, ApartmentOutlined };

// ==============================|| MENU ITEMS - CLIENTS ||============================== //

const clients = {
  id: 'clients',
  title: 'Clients',
  type: 'collapse',
  url: '/clients', // Add URL for clickable behavior
  icon: icons.TeamOutlined,
  permission: {
    module: 'clients',
    level: 10 // View permission required
  },
  children: [
    {
      id: 'divisions',
      title: 'Divisions',
      type: 'item',
      url: '/divisions',
      icon: icons.ApartmentOutlined,
      permission: {
        module: 'clients',
        level: 10 // Divisions use clients module permission (parent)
      }
    }
  ]
};

export default clients;
